module.exports = __webpack_public_path__ + "static/media/footerImage.bde28ae7.jpg";